import { ProductListItemProps } from '@graphcommerce/magento-product'
import { ProductListItemSimpleFragment } from '@graphcommerce/magento-product-simple/ProductListItemSimple.gql'
import { ProductListItem } from '../Product/ProductListItem/ProductListItem'

export type ProductListItemSimpleProps = ProductListItemSimpleFragment & ProductListItemProps

export function ProductListItemSimple(props: ProductListItemSimpleProps) {
  return <ProductListItem {...props} />
}
